var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "editor-row customize-editor-minimize" },
    [
      _c("div", { staticClass: "editor-row-title" }, [_vm._v("Delimiter")]),
      _vm._v(" "),
      _c("TiptapEditor", {
        attrs: {
          placeholder: "Delimiter: e.g. space, comma, etc.",
          "show-attributes": true,
          "show-emoji": false,
          "automation-mode": "",
        },
        model: {
          value: _vm.clone.split.delimiter,
          callback: function ($$v) {
            _vm.$set(_vm.clone.split, "delimiter", $$v)
          },
          expression: "clone.split.delimiter",
        },
      }),
      _vm._v(" "),
      _c("small", { staticClass: "description" }, [
        _vm._v(
          "\n        Enter the character or string that will be used to split the text\n    "
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }